import React from 'react'
import s from './index.module.css'
import { ArrowDownCircle } from '../../../../svg/arrow_down_circle'
import { withPrefix } from 'gatsby'
import { Helmet } from 'react-helmet'
import ResolvemosTusDudas from '../../../../components/aportes-y-fondo/tipos-de-aportes/independientes-por-yape/resolvemos-tus-dudas'

const Content = () => {
  return (
    <>
      <Helmet>
        <title>
          Aporta a tu fondo de pensiones de forma fácil y rápida con Yape |
          Prima AFP
        </title>
        <meta
          name="title"
          content="Aporta a tu fondo de pensiones de forma fácil y rápida con Yape | Prima AFP"
          data-react-helmet="true"
        />
        <meta
          name="description"
          content="Aporta a tu fondo de pensiones de forma fácil y rápida con Yape. ¡Sin filas ni complicaciones!"
          data-react-helmet="true"
        />
        <link
          rel="canonical"
          href="https://www.prima.com.pe/public-zone/aportes-y-fondo/tipos-de-aportes/independientes-por-yape/"
        />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Inicio",  "item": "https://www.prima.com.pe/public-zone/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Aportes y Fondo",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/"
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "Tipos de Aportes",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/tipos-de-aportes/"
                },
                {
                  "@type": "ListItem",
                  "position": 4,
                  "name": "Independientes por Yape",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/tipos-de-aportes/independientes-por-yape/"
                }
              ]
            }
          `}
        </script>
      </Helmet>

      <section className="tw-mt-8 tw-pt-18 tw-pt-18@lg bg-yellow-1 center left@lg">
        <div className={'containerWrap'}>
          <div className={`flex@lg`}>
            <div className={`w-100 w-50@lg`}>
              <div className="tw-mt-20@lg tw-pt-8@lg tw-mb-2 tw-mb-4@lg">
                <h2 className="font-family-secondary c-orange-0 fw-7 tw-f-24 tw-f-24@lg tw-m-0 tw-pr-12@lg">
                  ¿Puedo aportar a mi fondo de pensiones como independiente a
                  través de Yape?
                </h2>
              </div>

              <div className="tw-mb-4 tw-mb-4@lg">
                <p className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg">
                  Sí, tienes la alternativa de aportar a tu fondo de pensión
                  como afiliado independiente a través de Yape. Buscando mejorar
                  los canales por donde puedes aportar para tu jubilación,
                  implementamos este nuevo canal de pago fácil y seguro, ahora
                  puedes hacerlo a través de la funcionalidad de pago de
                  servicios de Yape. Esta opción nos permite acercarnos más a ti
                  e impulsar el ahorro previsional.
                </p>
              </div>
            </div>

            <div className={`w-100 w-50@lg relative`}>
              <img
                src={withPrefix('/images/man-black-with-yape.svg')}
                alt="man-black-with-yape"
                className={`${s.imagenBoxYape1} relative ml-auto@lg`}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="tw-pt-18 tw-pt-18@lg bg-turquoise-1 pb-0 pb-1@md pb-3@lg center left@lg">
        <div className={'containerWrap'}>
          <div className={`flex direction-column direction-row@lg`}>
            <div
              className={`w-100 w-50@lg order-2 order-1@lg relative tw-mt-8 tw-mt-0@lg`}
            >
              <img
                src={withPrefix('/images/people-with-smartphone.svg')}
                alt="people-with-smartphone"
                className={`${s.imagenBoxYape2} relative`}
              />
            </div>

            <div className={`w-100 w-50@lg order-1 order-2@lg`}>
              <h2 className="font-family-secondary c-turquoise-0 fw-7 tw-f-24 tw-f-24@lg tw-mt-4@lg tw-mb-2 tw-mb-4@lg">
                ¿Cuál es la finalidad de Yapear a mi fondo de pensión?
              </h2>
              <div className="tw-mb-8 tw-mb-8@lg">
                <p className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg">
                  La finalidad es que ahorres de una manera sencilla en tu
                  cuenta individual y disfrutes de ese ahorro cuando llegué el
                  momento de tu jubilación. Además, ahorrar mensualmente te
                  permite estar protegido con una pensión de invalidez en caso
                  sufras un accidente o enfermedad; y protege a tu familia con
                  una pensión de sobrevivencia en caso fallecieras.
                </p>
              </div>

              <div className={`flex`}>
                <div className={`w-30 w-20@lg`}>
                  <div className={`tw-py-0@lg tw-pr-2 tw-pr-0@lg`}>
                    <img
                      src={withPrefix('/images/click-yape.svg')}
                      alt="click-yape"
                      className={`${s.imagenBoxYape3}`}
                    />
                  </div>
                </div>
                <div className={`w-70 w-80@lg`}>
                  <div
                    className={`border border-turquoise-0 brad-4 tw-p-6 font-family-primary tw-f-16 tw-f-16@lg`}
                  >
                    Toma en cuenta que mientras más alto y frecuente sea el
                    aporte que realices, <strong>tu fondo crecerá más</strong>.
                    Por nuestro lado, el equipo de inversiones también hará que
                    tu fondo crezca generando rentabilidad.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={`containerWrap bg-thite`}>
        <div className={`tw-px-8 tw-px-18@lg tw-py-12 tw-py-18@lg`}>
          <div
            className={`center font-family-primary c-black-0 tw-f-16 tw-f-16@lg tw-mb-2`}
          >
            Aportes independientes por Yape
          </div>

          <h2
            className={`center font-family-secondary tw-f-24 tw-f-24@lg tw-mt-0 tw-mb-4 tw-px-0 tw-px-12@lg`}
          >
            ¿Cómo puedo aportar a mi fondo desde Yape?
          </h2>

          <div
            className={`center font-family-primary c-black-0 tw-f-16 tw-f-16@lg tw-mb-4`}
          >
            Sigue estos simples pasos:
          </div>

          <div className={`center`}>
            <ArrowDownCircle fill={'#45494E'} />
          </div>

          <div className={`tw-mb-2 ${s.imagenBoxWrapYape}`}>
            <img
              src={withPrefix('/images/steps-yape-1.svg')}
              alt="steps-yape"
              className={`${s.imagenBoxYape}`}
            />
          </div>

          <div
            className={`center font-family-primary c-black-0 tw-f-16 tw-f-16@lg tw-mb-20`}
          >
            Recuerda que tu aporte se debe calcular considerando un ingreso no
            menor a la Remuneración Mínima Vital vigente en el momento del pago.
            Después de realizar el pago, recibirás un correo electrónico con los
            detalles de tu aporte, incluyendo cómo se distribuye el dinero en tu
            cuenta de jubilación, el seguro de invalidez, sobrevivencia y la
            comisión de la AFP, si corresponde.
          </div>

          <ResolvemosTusDudas />
        </div>
      </section>
    </>
  )
}

export default Content
